import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from 'primeng/primeng';
import { AuthService } from '../auth/services/auth.service';
import { UserService } from '../auth/services/user.service';
import { IUser } from '../auth/models/IUser';
import { IHeaderAction } from './IHeaderAction';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
  user: IUser;
  items: MenuItem[];
  @Input() actionLeft: IHeaderAction ;

  constructor(private userService: UserService, private authService: AuthService) { }

  ngOnInit() {
    this.user = this.userService.user;
    this.items = [{icon: 'fa fa-sign-out', label: 'Logout', command: () => this.onLogout()}];
  }

  onLogout() {
    this.authService.logout();
  }
}
